define(["./externalFreightModule"], function (externalFreightService) {
    "use strict";

    return externalFreightService.service("externalFreightService", ["$http", "loadingService", "messagesModal", "remoteExceptionHandler", "externalFreightServiceUrl", "externalFreightOptionsModal",
        function ($http, loadingService, messagesModal, remoteExceptionHandler, externalFreightServiceUrl, externalFreightOptionsModal) {

            return {
                calculateFreightUrlForNodeIdentifier: calculateFreightUrlForNodeIdentifier
            };

            function calculateFreightUrlForNodeIdentifier(nodeIdentifiers, context) {
                return loadingService($http.post(externalFreightServiceUrl.getCalculateFreightUrlForNodeIdentifier(), nodeIdentifiers)
                    .success(function (response) {
                        return externalFreightOptionsModal(response.externalFreights, context);
                    })
                    .error(function (response) {
                        return messagesModal("dialog.error", response.messages).then(function () {
                            return context.refilter();
                        });
                    }));
            }
        }]);
});